/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

export const HeadingSectionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${({ marginBottom }) => marginBottom};

  @media screen and (max-width: 767px) {
    margin-bottom: ${({ marginBottomMobile }) => marginBottomMobile};
  }
`;

export const HeadingSection = styled.h1`
  font-size: ${({ small, extraSmall }) =>
    extraSmall ? '20px' : small ? '24px' : '32px'};
  font-weight: 700;
  line-height: 1.3;
  z-index: 1;
  color: ${({ goldHeading, blueHeading }) =>
    goldHeading
      ? 'var(--gold-2)'
      : blueHeading
      ? 'var(--blue-2)'
      : 'var(--foreground-white)'};
  max-width: ${({ fullWidth }) => !fullWidth && '500px'};

  @media screen and (max-width: 810px) {
    font-size: var(--font-size-4);
  }
`;

export const SubtitleSection = styled.p`
  font-size: var(--font-size-2);
  font-weight: 500;
  line-height: 1.6;
  max-width: 500px;
  color: ${({ gold }) => (gold ? 'var(--foreground-white)' : 'var(--blue-2)')};

  @media screen and (max-width: 480px) {
    font-size: ${({ mobileSmaller }) => mobileSmaller && 'var(--font-size)'};
  }
`;

export const HeadingUppercase = styled.h2`
  font-size: var(--font-size-4);
  font-weight: 700;
  line-height: 1.3;
  text-transform: uppercase;
  color: var(--foreground-white);
`;

export const SmallParagraph = styled.p`
  font-size: var(--font-size-micro);
  color: var(--blue-2);
`;

export const RegularParagraph = styled.p`
  font-size: var(--font-size);
  color: var(--blue-2);

  @media screen and (max-width: 810px) {
    font-size: var(--font-size-2);
  }

  @media screen and (max-width: 360px) {
    font-size: ${({ isXmas }) => isXmas && 'var(--font-size)'};
  }
`;

export const TextBoxGeneric = styled.div`
  display: grid;
  row-gap: ${({ rowGap }) => rowGap};
  height: min-content;
`;
